{
  "thirdparty": {
    "expedia": {
      "legalModal": {
        "title": "Muiden matkapalveluiden varaaminen",
        "expandTitle": "Katso lisätietoja maksukyvyttömyyssuojasta",
        "poweredBy": "Palvelun tarjoaa"
      }
    }
  },
  "fragments": {
    "expediaHotelsLegislationModal": {
      "localSettings": {},
      "url": "/en/3939006-3939006"
    },
    "expediaHotelsLegislationModalExpanded": {
      "localSettings": {},
      "url": "/en/3938984-3938984"
    }
  }
}
